// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1ECH1","content":"RecentSearches_content__1etgS"};